module.exports = __webpack_public_path__ + "img/bank-generic-logo.97bc4ff6.png";